"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import { BinIcon, Text, TextColor, TextSize, TextWeight } from "../../components";
import { extractColor, extractSize } from "../../utils";

// Skeleton komponent dla ładowania
export const ProductListItemSkeleton = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full h-[200px] bg-gray-200 mb-4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex-1 space-y-2"><div className="h-4 bg-gray-200 rounded w-3/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col sm:hidden">{t0}<div className="flex flex-col gap-4">{t1}<div className="flex justify-end"><div className="text-right space-y-2"><div className="h-4 bg-gray-200 rounded w-16" /><div className="h-3 bg-gray-200 rounded w-12" /><div className="h-3 bg-gray-200 rounded w-12" /></div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-[90px] h-[135px] bg-gray-200 flex-shrink-0" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex-1 space-y-2"><div className="h-4 bg-gray-200 rounded w-3/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /><div className="h-3 bg-gray-200 rounded w-1/4" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="p-4 bg-white border border-gray-100 animate-pulse">{t2}<div className="hidden sm:flex items-start gap-4">{t3}{t4}<div className="text-right space-y-2"><div className="h-4 bg-gray-200 rounded w-16" /><div className="h-3 bg-gray-200 rounded w-12" /><div className="h-3 bg-gray-200 rounded w-12" /></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
// Komponent dla pojedynczego produktu
export const ProductListItem = t0 => {
  const $ = _c(137);
  const {
    product,
    showQuantityControls: t1,
    showRemoveButton: t2,
    onQuantityChange,
    simplified: t3,
    loading: t4,
    deleteProductFromCart,
    productUrlAvailable: t5
  } = t0;
  const showQuantityControls = t1 === undefined ? false : t1;
  const showRemoveButton = t2 === undefined ? false : t2;
  const simplified = t3 === undefined ? false : t3;
  const loading = t4 === undefined ? false : t4;
  const productUrlAvailable = t5 === undefined ? false : t5;
  const [imageError, setImageError] = useState(false);
  const [quantity, setQuantity] = useState(product.quantity);
  let t6;
  if ($[0] !== onQuantityChange || $[1] !== product.idProduct || $[2] !== product.idProductAttribute || $[3] !== product.quantity) {
    t6 = newQuantity => {
      if (newQuantity < 1) {
        return;
      }
      setQuantity(newQuantity);
      onQuantityChange?.(Number(product.idProduct), Number(product.idProductAttribute), 1, product.quantity > newQuantity ? "down" : "up");
    };
    $[0] = onQuantityChange;
    $[1] = product.idProduct;
    $[2] = product.idProductAttribute;
    $[3] = product.quantity;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleQuantityChange = t6;
  let t7;
  if ($[5] !== deleteProductFromCart || $[6] !== product.idProduct || $[7] !== product.idProductAttribute) {
    t7 = () => {
      deleteProductFromCart?.(Number(product.idProduct), Number(product.idProductAttribute));
    };
    $[5] = deleteProductFromCart;
    $[6] = product.idProduct;
    $[7] = product.idProductAttribute;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleRemoveProduct = t7;
  const getProductImageUrl = _temp;
  let t8;
  if ($[9] !== product) {
    t8 = getProductImageUrl(product);
    $[9] = product;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const imageUrl = t8;
  if (simplified) {
    let t9;
    if ($[11] !== imageError || $[12] !== imageUrl || $[13] !== product.name) {
      t9 = <div className="flex !w-[100px] h-[150px] bg-gray-100 flex items-center justify-center">{imageUrl && !imageError ? <Image src={imageUrl} alt={product.name || "Produkt"} width={100} height={150} className="object-cover max-h-full max-w-full" onError={() => setImageError(true)} placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q==" /> : <span className="text-gray-400 text-lg text-center">IMG</span>}</div>;
      $[11] = imageError;
      $[12] = imageUrl;
      $[13] = product.name;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] !== product.name || $[16] !== product.url || $[17] !== productUrlAvailable) {
      t10 = productUrlAvailable ? <Link href={`/${product.url}`}><Text text={product.name} fontSize={TextSize.M} weight={TextWeight.MEDIUM} /></Link> : <Text text={product.name} fontSize={TextSize.M} weight={TextWeight.MEDIUM} />;
      $[15] = product.name;
      $[16] = product.url;
      $[17] = productUrlAvailable;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    const t11 = product.attributesArray || product.attributes;
    let t12;
    if ($[19] !== t11) {
      t12 = extractSize(t11);
      $[19] = t11;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    let t13;
    if ($[21] !== t12) {
      t13 = <Text text={t12} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_500} />;
      $[21] = t12;
      $[22] = t13;
    } else {
      t13 = $[22];
    }
    let t14;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Text text={"\u2022"} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_500} />;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    const t15 = product.attributesArray?.Kolor || "Kolor";
    let t16;
    if ($[24] !== t15) {
      t16 = <Text text={t15} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_500} />;
      $[24] = t15;
      $[25] = t16;
    } else {
      t16 = $[25];
    }
    let t17;
    if ($[26] !== t13 || $[27] !== t16) {
      t17 = <div className="flex items-center gap-2">{t13}{t14}{t16}</div>;
      $[26] = t13;
      $[27] = t16;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    const t18 = `Liczba sztuk: ${product.quantity}`;
    let t19;
    if ($[29] !== t18) {
      t19 = <Text text={t18} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_500} />;
      $[29] = t18;
      $[30] = t19;
    } else {
      t19 = $[30];
    }
    let t20;
    if ($[31] !== t10 || $[32] !== t17 || $[33] !== t19) {
      t20 = <div className="flex flex-col gap-1">{t10}{t17}{t19}</div>;
      $[31] = t10;
      $[32] = t17;
      $[33] = t19;
      $[34] = t20;
    } else {
      t20 = $[34];
    }
    let t21;
    if ($[35] !== product.formattedTotal) {
      t21 = <Text text={product.formattedTotal} fontSize={TextSize.XL} weight={TextWeight.BOLD} className="self-end" />;
      $[35] = product.formattedTotal;
      $[36] = t21;
    } else {
      t21 = $[36];
    }
    let t22;
    if ($[37] !== product.formattedTotalRegularPrice || $[38] !== product.totalAmount || $[39] !== product.totalRegularAmount) {
      t22 = product.totalAmount !== product.totalRegularAmount && <div className="flex flex-col items-end gap-1"><div className="flex gap-1"><Text text={product.formattedTotalRegularPrice} color={TextColor.GRAYSCALE_400} fontSize={TextSize.XS} weight={TextWeight.BOLD} className="text-right" textDecoration="line-through" /></div></div>;
      $[37] = product.formattedTotalRegularPrice;
      $[38] = product.totalAmount;
      $[39] = product.totalRegularAmount;
      $[40] = t22;
    } else {
      t22 = $[40];
    }
    let t23;
    if ($[41] !== t21 || $[42] !== t22) {
      t23 = <div className="flex flex-row gap-2 items-center justify-end">{t21}{t22}</div>;
      $[41] = t21;
      $[42] = t22;
      $[43] = t23;
    } else {
      t23 = $[43];
    }
    let t24;
    if ($[44] !== t20 || $[45] !== t23) {
      t24 = <div className="flex w-[calc(100%-100px-16px)] flex-col justify-between min-w-0 my-2">{t20}{t23}</div>;
      $[44] = t20;
      $[45] = t23;
      $[46] = t24;
    } else {
      t24 = $[46];
    }
    let t25;
    if ($[47] !== t24 || $[48] !== t9) {
      t25 = <div className="w-full relative"><div className="flex gap-3">{t9}{t24}</div></div>;
      $[47] = t24;
      $[48] = t9;
      $[49] = t25;
    } else {
      t25 = $[49];
    }
    return t25;
  }
  let t9;
  if ($[50] !== imageError || $[51] !== imageUrl || $[52] !== product.name) {
    t9 = <div className="w-full h-auto md:h-[200px] flex items-center justify-center mb-4">{imageUrl && !imageError ? <Image src={imageUrl} alt={product.name || "Produkt"} width={200} height={200} className="object-contain md:object-cover max-h-full max-w-full" onError={() => setImageError(true)} placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q==" /> : <span className="text-gray-400 text-lg text-center">IMG</span>}</div>;
    $[50] = imageError;
    $[51] = imageUrl;
    $[52] = product.name;
    $[53] = t9;
  } else {
    t9 = $[53];
  }
  let t10;
  if ($[54] !== product.name || $[55] !== product.url || $[56] !== productUrlAvailable) {
    t10 = productUrlAvailable ? <Link href={`/${product.url}`}><Text text={product.name} fontSize={TextSize.M} weight={TextWeight.BOLD} /></Link> : <Text text={product.name} fontSize={TextSize.M} weight={TextWeight.BOLD} />;
    $[54] = product.name;
    $[55] = product.url;
    $[56] = productUrlAvailable;
    $[57] = t10;
  } else {
    t10 = $[57];
  }
  const t11 = `Rozmiar: ${extractSize(product.attributesArray || product.attributes)}`;
  let t12;
  if ($[58] !== t11) {
    t12 = <Text text={t11} fontSize={TextSize.S} />;
    $[58] = t11;
    $[59] = t12;
  } else {
    t12 = $[59];
  }
  const t13 = `Kolor: ${extractColor(product.attributesArray || product.attributes)}`;
  let t14;
  if ($[60] !== t13) {
    t14 = <Text text={t13} fontSize={TextSize.S} />;
    $[60] = t13;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  const t15 = `Indeks: ${product.reference}`;
  let t16;
  if ($[62] !== t15) {
    t16 = <Text text={t15} fontSize={TextSize.S} />;
    $[62] = t15;
    $[63] = t16;
  } else {
    t16 = $[63];
  }
  let t17;
  if ($[64] !== handleQuantityChange || $[65] !== product.quantity || $[66] !== quantity || $[67] !== showQuantityControls) {
    t17 = showQuantityControls ? <div className="flex items-center gap-2"><Text text="Liczba sztuk:" fontSize={TextSize.S} /><div className="flex items-center gap-2 bg-gray-50 rounded-lg px-2 py-1"><button onClick={() => handleQuantityChange(quantity - 1)} className={`w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded ${quantity <= 1 ? "opacity-50 cursor-not-allowed" : ""}`} disabled={quantity <= 1}>-</button><span className="min-w-[20px] text-center text-sm">{quantity}</span><button onClick={() => handleQuantityChange(quantity + 1)} className="w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded">+</button></div></div> : <Text text={`Liczba sztuk: ${product.quantity}`} fontSize={TextSize.S} />;
    $[64] = handleQuantityChange;
    $[65] = product.quantity;
    $[66] = quantity;
    $[67] = showQuantityControls;
    $[68] = t17;
  } else {
    t17 = $[68];
  }
  let t18;
  if ($[69] !== t10 || $[70] !== t12 || $[71] !== t14 || $[72] !== t16 || $[73] !== t17) {
    t18 = <div className="flex-1 flex flex-col gap-1">{t10}{t12}{t14}{t16}{t17}</div>;
    $[69] = t10;
    $[70] = t12;
    $[71] = t14;
    $[72] = t16;
    $[73] = t17;
    $[74] = t18;
  } else {
    t18 = $[74];
  }
  let t19;
  if ($[75] !== loading || $[76] !== product.formattedTotal) {
    t19 = loading ? <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" /> : <Text text={product.formattedTotal} fontSize={TextSize.L} weight={TextWeight.BOLD} />;
    $[75] = loading;
    $[76] = product.formattedTotal;
    $[77] = t19;
  } else {
    t19 = $[77];
  }
  let t20;
  if ($[78] !== product.formattedDiscountToDisplay || $[79] !== product.formattedRegularPrice || $[80] !== product.lowestPrice || $[81] !== product.totalAmount || $[82] !== product.totalRegularAmount) {
    t20 = product.totalAmount !== product.totalRegularAmount && <div className="flex flex-col items-end gap-1 mt-2"><div className="flex gap-1"><Text text="Cena regularna:" fontSize={TextSize.XS} /><Text text={product.formattedRegularPrice} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_700} /></div><div className="flex gap-1"><Text text="Rabat:" fontSize={TextSize.XS} /><Text text={product.formattedDiscountToDisplay} fontSize={TextSize.XS} color={TextColor.ERROR_700} /></div>{product.lowestPrice && <div className="flex gap-1"><Text text={`Najniższa cena z 30 dni przed obniżką: ${product.lowestPrice}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_700} /></div>}</div>;
    $[78] = product.formattedDiscountToDisplay;
    $[79] = product.formattedRegularPrice;
    $[80] = product.lowestPrice;
    $[81] = product.totalAmount;
    $[82] = product.totalRegularAmount;
    $[83] = t20;
  } else {
    t20 = $[83];
  }
  let t21;
  if ($[84] !== t19 || $[85] !== t20) {
    t21 = <div className="flex justify-between items-end"><div className="text-right flex-1">{t19}{t20}</div></div>;
    $[84] = t19;
    $[85] = t20;
    $[86] = t21;
  } else {
    t21 = $[86];
  }
  let t22;
  if ($[87] !== t18 || $[88] !== t21) {
    t22 = <div className="flex flex-col gap-4">{t18}{t21}</div>;
    $[87] = t18;
    $[88] = t21;
    $[89] = t22;
  } else {
    t22 = $[89];
  }
  let t23;
  if ($[90] !== t22 || $[91] !== t9) {
    t23 = <div className="flex flex-col sm:hidden">{t9}{t22}</div>;
    $[90] = t22;
    $[91] = t9;
    $[92] = t23;
  } else {
    t23 = $[92];
  }
  let t24;
  if ($[93] !== imageError || $[94] !== imageUrl || $[95] !== product.name) {
    t24 = <div className="w-[90px] h-[135px] bg-gray-100 flex-shrink-0 flex items-center justify-center">{imageUrl && !imageError ? <Image src={imageUrl} alt={product.name || "Produkt"} width={90} height={135} className="object-cover" onError={() => setImageError(true)} placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q==" /> : <span className="text-gray-400 text-xs text-center">IMG</span>}</div>;
    $[93] = imageError;
    $[94] = imageUrl;
    $[95] = product.name;
    $[96] = t24;
  } else {
    t24 = $[96];
  }
  let t25;
  if ($[97] !== product.name || $[98] !== product.url || $[99] !== productUrlAvailable) {
    t25 = productUrlAvailable ? <Link href={`/${product.url}`}><Text text={product.name} fontSize={TextSize.M} weight={TextWeight.BOLD} /></Link> : <Text text={product.name} fontSize={TextSize.M} weight={TextWeight.BOLD} />;
    $[97] = product.name;
    $[98] = product.url;
    $[99] = productUrlAvailable;
    $[100] = t25;
  } else {
    t25 = $[100];
  }
  const t26 = `Rozmiar: ${extractSize(product.attributesArray || product.attributes)}`;
  let t27;
  if ($[101] !== t26) {
    t27 = <Text text={t26} fontSize={TextSize.S} />;
    $[101] = t26;
    $[102] = t27;
  } else {
    t27 = $[102];
  }
  const t28 = `Kolor: ${extractColor(product.attributesArray || product.attributes)}`;
  let t29;
  if ($[103] !== t28) {
    t29 = <Text text={t28} fontSize={TextSize.S} />;
    $[103] = t28;
    $[104] = t29;
  } else {
    t29 = $[104];
  }
  const t30 = `Indeks: ${product.reference}`;
  let t31;
  if ($[105] !== t30) {
    t31 = <Text text={t30} fontSize={TextSize.S} />;
    $[105] = t30;
    $[106] = t31;
  } else {
    t31 = $[106];
  }
  let t32;
  if ($[107] !== handleQuantityChange || $[108] !== product.quantity || $[109] !== quantity || $[110] !== showQuantityControls) {
    t32 = showQuantityControls ? <div className="flex items-center gap-2"><Text text="Liczba sztuk:" fontSize={TextSize.S} /><div className="flex items-center gap-2 bg-gray-50 rounded-lg px-2 py-1"><button onClick={() => handleQuantityChange(quantity - 1)} className={`w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded ${quantity <= 1 ? "opacity-50 cursor-not-allowed" : ""}`} disabled={quantity <= 1}>-</button><span className="min-w-[20px] text-center text-sm">{quantity}</span><button onClick={() => handleQuantityChange(quantity + 1)} className="w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded">+</button></div></div> : <Text text={`Liczba sztuk: ${product.quantity}`} fontSize={TextSize.S} />;
    $[107] = handleQuantityChange;
    $[108] = product.quantity;
    $[109] = quantity;
    $[110] = showQuantityControls;
    $[111] = t32;
  } else {
    t32 = $[111];
  }
  let t33;
  if ($[112] !== t25 || $[113] !== t27 || $[114] !== t29 || $[115] !== t31 || $[116] !== t32) {
    t33 = <div className="flex-1 flex flex-col gap-1">{t25}{t27}{t29}{t31}{t32}</div>;
    $[112] = t25;
    $[113] = t27;
    $[114] = t29;
    $[115] = t31;
    $[116] = t32;
    $[117] = t33;
  } else {
    t33 = $[117];
  }
  let t34;
  if ($[118] !== loading || $[119] !== product.formattedDiscountToDisplay || $[120] !== product.formattedTotal || $[121] !== product.formattedTotalRegularPrice || $[122] !== product.lowestPrice || $[123] !== product.totalAmount || $[124] !== product.totalRegularAmount) {
    t34 = <div className="flex flex-col items-end gap-4"><div className="text-right">{loading ? <div className="flex flex-col items-end gap-2"><div className="h-6 w-20 bg-gray-200 rounded animate-pulse" />{product.totalAmount !== product.totalRegularAmount && <><div className="h-3 w-[120px] bg-gray-200 rounded animate-pulse" /><div className="h-3 w-10 bg-gray-200 rounded animate-pulse" /></>}</div> : <><Text text={product.formattedTotal} fontSize={TextSize.L} weight={TextWeight.BOLD} />{product.totalAmount !== product.totalRegularAmount && <div className="flex flex-col items-end gap-1"><div className="flex gap-1"><Text text="Cena regularna:" fontSize={TextSize.XS} /><Text text={product.formattedTotalRegularPrice} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_700} /></div><div className="flex gap-1"><Text text="Rabat:" fontSize={TextSize.XS} /><Text text={product.formattedDiscountToDisplay} fontSize={TextSize.XS} color={TextColor.ERROR_700} /></div>{product.lowestPrice && <div className="flex gap-1"><Text text={`Najniższa cena z 30 dni przed obniżką: ${product.lowestPrice}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_700} /></div>}</div>}</>}</div></div>;
    $[118] = loading;
    $[119] = product.formattedDiscountToDisplay;
    $[120] = product.formattedTotal;
    $[121] = product.formattedTotalRegularPrice;
    $[122] = product.lowestPrice;
    $[123] = product.totalAmount;
    $[124] = product.totalRegularAmount;
    $[125] = t34;
  } else {
    t34 = $[125];
  }
  let t35;
  if ($[126] !== t24 || $[127] !== t33 || $[128] !== t34) {
    t35 = <div className="hidden sm:flex items-start gap-4">{t24}{t33}{t34}</div>;
    $[126] = t24;
    $[127] = t33;
    $[128] = t34;
    $[129] = t35;
  } else {
    t35 = $[129];
  }
  let t36;
  if ($[130] !== handleRemoveProduct || $[131] !== showRemoveButton) {
    t36 = showRemoveButton && <button onClick={handleRemoveProduct} className="absolute bottom-4 left-4 sm:left-auto sm:right-4 text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" title={"Usu\u0144 z koszyka"}><BinIcon /></button>;
    $[130] = handleRemoveProduct;
    $[131] = showRemoveButton;
    $[132] = t36;
  } else {
    t36 = $[132];
  }
  let t37;
  if ($[133] !== t23 || $[134] !== t35 || $[135] !== t36) {
    t37 = <div className="p-4 bg-white border border-gray-100 relative">{t23}{t35}{t36}</div>;
    $[133] = t23;
    $[134] = t35;
    $[135] = t36;
    $[136] = t37;
  } else {
    t37 = $[136];
  }
  return t37;
};
function _temp(product_0) {
  const imageId = product_0.image?.idImage || product_0.cover?.idImage;
  const productName = product_0.name || product_0.productName;
  if (imageId && productName) {
    const slug = productName.toLowerCase().replace(/ą/g, "a").replace(/ć/g, "c").replace(/ę/g, "e").replace(/ł/g, "l").replace(/ń/g, "n").replace(/ó/g, "o").replace(/ś/g, "s").replace(/ź/g, "z").replace(/ż/g, "z").replace(/[^a-z0-9\s-]/g, "").replace(/[\s_]+/g, "-").replace(/-+/g, "-").trim("-");
    return `${"https://shop.carry.pl"}/${imageId}-cart_default/${slug}.jpg`;
  }
  if (product_0.imageUrl) {
    return product_0.imageUrl.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl");
  }
  if (product_0.idProduct) {
    return `${"https://shop.carry.pl"}/${product_0.idProduct}-cart_default.jpg`;
  }
  return null;
}